import { useInfiniteQuery } from "react-query";

import { useMemo } from "react";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import {
  GetNotifyNotificationContentParamsType,
  GetNotifyPublicNotificationContentParamsType,
  getNotifySearchNotificationContent,
} from "../../../queries/notify";

export function useInfiniteNotificationContent(params: GetNotifyNotificationContentParamsType) {
  const headers = useNetworkHeaders();

  const {
    data,
    isLoading: isNotificationContentLoading,
    isFetching: isNotificationContentFetching,
    fetchMore: fetchMoreNotificationContent,
    canFetchMore: canFetchMoreNotificationContent,
  } = useInfiniteQuery(
    buildNotifyInfiniteNotificationContentQueryKey(params),
    getNotifySearchNotificationContent(headers),
    {
      queryFnParamsFilter(args) {
        return [args[1]];
      },
      getFetchMore: (lastPage) => {
        return lastPage.data.at(-1)?.cursor?.join(",");
      },
      keepPreviousData: true,
    },
  );
  const notifyContent = useMemo(() => data?.flatMap(({ data }) => data) ?? [], [data]);

  const lastPage = data?.at(-1);

  return {
    total: lastPage?.total ?? 0,
    notifyContent,
    isNotificationContentLoading,
    isNotificationContentFetching,
    fetchMoreNotificationContent,
    canFetchMoreNotificationContent,
  };
}

export function buildNotifyInfiniteNotificationContentQueryKey(params?: GetNotifyPublicNotificationContentParamsType) {
  if (!params) {
    return "useInfiniteNotificationContent";
  }
  return ["useInfiniteNotificationContent", params];
}
